/**
 * Text field with optional start/end icons and multiline support.
 */
import { InputAdornment, TextField, Icon } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

import { asFunc, asNumber, asString } from "utils/safeData";

/**
 * Controlled text input that writes changes through `setValue`.
 *
 * @param {{ inputClassName?: string, InputClassName?: string, label?: React.ReactNode, value?: string|number, setValue?: Function, startIcon?: React.ReactNode, endIcon?: React.ReactNode, rows?: number }} props
 */
const VInput = (props) => {
  const { inputClassName, InputClassName, label, value: rawValue, setValue: rawSetValue, startIcon, endIcon, ...rest } = props;
  const value = asString(rawValue);
  const setValue = asFunc(rawSetValue);
  const rows = asNumber(props.rows, 1);

  const inputProps = startIcon
    ? {
        startAdornment: (
          <InputAdornment position="start">
            <Icon className={InputClassName}>{startIcon}</Icon>
          </InputAdornment>
        ),
      }
    : endIcon
    ? {
        endAdornment: (
          <InputAdornment position="start">
            <Icon className={InputClassName}>{endIcon}</Icon>
          </InputAdornment>
        ),
      }
    : {};

  return (
    <>
      <TextField
        label={label}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        multiline={rows && rows > 1 ? true : false}
        rows={rows && rows > 1 ? rows : 1}
        InputProps={{
          ...inputProps,
          className: InputClassName,
        }}
        inputProps={{
          className: inputClassName,
        }}
        {...rest}
      />
    </>
  );
};

VInput.defaultProps = {
  InputClassName: "",
  value: "",
  setValue: () => {},
  rows: 1,
  variant: "outlined", // filled, standard
  startIcon: null,
  endIcon: null,
};

VInput.propTypes = {
  inputClassName: PropTypes.string,
  InputClassName: PropTypes.string,
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setValue: PropTypes.func,
  rows: PropTypes.number,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
};

export default VInput;
